{
  "clusterServices": "My services",
  "allServices": "All services",
  "serviceCatalog": "Service catalog",
  "activeServices": "Active services",
  "addService": "Add service",
  "editService": "Edit service",
  "notification.text": "This button takes you to Felles tjenestekatalog. You will soon be able to add services in Flerbedriftsportalen.",
  "details.header": "About service",
  "details.validFrom": "Service valid from",
  "details.validTo": "Service valid to",
  "details.description": "Service description",
  "details.customerDescription": "Service description for customer",
  "details.purpose": "Service purpose",
  "details.links": "Links",
  "details.targetAudience": "Target audience",
  "details.companyAge": "Company age requirements",
  "details.companySize": "Company size requirements",
  "details.customerSegment": "Customer segment relevancy",
  "details.customerSegmentComment": "Customer segment notes",
  "details.delivery": "Delivery",
  "details.deliveryType": "Delivery type",
  "details.deliveryDescription": "How the service is delivered",
  "details.deadline": "Appplication deadline",
  "details.userFee": "User fee",
  "details.userFeeComment": "Userfee notes",
  "details.contact": "Service supplier and contact info",
  "details.origin": "Service supplier",
  "details.contract": "Client",
  "details.EEA": "EEA-articles",
  "details.EEAarticles": "Applicable EEA-articles",
  "details.Error": "Could not get service. Try again or contact support.",

  "form.edit": "Edit service",
  "form.publish": "Publish",
  "form.publishChanges": "Publish changes",
  "form.saveAsDraft": "Save and close",
  "form.deleteDraft": "Delete draft",
  "form.next": "Next",
  "form.back": "Previous",
  "form.add": "Add",
  "form.edit.button": "Edit",
  "form.yes": "Yes",
  "form.no": "No",

  "about.title": "About the service",
  "about.serviceName.label": "What is the name of the service?",
  "about.serviceName.help": "Enter the Norwegian name of the service as used in customer dialogue and on the website.",
  "about.serviceName.required": "Please enter the name of the service",
  "about.serviceName.maxLength": "The service name can be a maximum of 500 characters",
  "about.validFrom.label": "The service is valid from",
  "about.validFrom.required": "Please enter the date the service is valid from",
  "about.validTo.label": "The service is valid until",
  "about.validTo.required": "Please enter the date the service is valid until",
  "about.validTo.beforeValidFrom": "The valid until date cannot be before the valid from date",
  "about.description.label": "How would you describe the service?",
  "about.description.help": "Briefly describe the content of the service as if you were explaining it to someone who has never heard of it before.",
  "about.description.required": "Please describe the content of the service",
  "about.purpose.label": "What is the purpose of the service?",
  "about.purpose.help": "Briefly describe why this service is offered. Explain what effect the service should have on society/business. Are there concrete effects that the client wants to achieve? What makes the service important to society?",
  "about.purpose.required": "Please describe the purpose of the service",
  "about.purpose.maxLength": "The purpose can be a maximum of 500 charactersq",
  "about.keywords.label": "Which keywords are relevant for the service? (Add one word at a time)",
  "about.keywords.help": "Write keywords that are often used when this service is relevant. These words are used in searches and algorithms.",
  "about.keywords.required": "Please add keywords",
  "about.links.title": "Which links are relevant for the service?",
  "about.links.help": "Add links that are especially relevant for advisors or customers.",
  "about.links.text": "Display text",
  "about.links.url": "Enter URL",
  "about.customerDescription.label": "How would you describe the service as a sales pitch to the customer in an email?",
  "about.customerDescription.help": "Describe the service for customers. The description is used in emails to customers when they are recommended the service.",

  "target.title": "Target group and geographic catchment area",
  "target.companyAge.label": "Are there requirements for the company's age?",
  "target.companyAge.help": "Select requirements for the company's age.",
  "target.companyAge.required": "Please select an option",
  "target.companySize.label": "Are there requirements for company size?",
  "target.companySize.help": "Select requirements for the company's size.",
  "target.companySize.required": "Please select one or more options",
  "target.innovationLevelCriteria.placeholder": "Select level",
  "target.innovationLevelCriteria.title": "Innovation level",
  "target.innovationLevelCriteria.label": "Does the service have requirements for the company's innovation level?",
  "target.innovationLevelCriteria.help": "Select requirements for the company's innovation level.",
  "target.innovationLevelCriteria.required": "Select innovation level",
  "target.innovationLevelCriteria.CompanyLevel": "Company level",
  "target.innovationLevelCriteria.RegionalLevel": "Regional level",
  "target.innovationLevelCriteria.NationalLevel": "National level",
  "target.innovationLevelCriteria.InternationalLevel": "International level",
  "target.innovationLevelCriteria.NotRelevant": "Not relevant",
  "target.innovationLevelCriteria.Unknown": "Unknown",
  "target.customerSegment.label": "Is the service only relevant for selected customer segments?",
  "target.customerSegment.help": "Select relevant customer segments.",
  "target.customerSegment.required": "Please select one or more options",
  "target.customerSegment.addComment": "Add comment",
  "target.customerSegment.comment.label": "Comment on customer segment",
  "target.customerSegment.comment.help": "Elaborate here if the service targets sector-specific industries.",
  "target.districtPolicy.label": "Must the activity be carried out within district policy areas?",
  "target.districtPolicy.help": "Is the service only relevant for projects within district policy areas (DVP)? Select Yes or No.",
  "target.geographic.label": "For which area does the service apply?",
  "target.geographic.help": "Select all counties/municipalities where you deliver this service.",
  "target.geographic.dialogTitle": "Add geographic catchment area",
  "target.geographic.required": "Please add at least one county or municipality",

  "delivery.title": "Delivery",
  "delivery.type.label": "What is the primary delivery type for the service?",
  "delivery.type.help": "Specify the primary delivery type/delivery form for the service. Select one or more.",
  "delivery.type.required": "Please select one or more options",
  "delivery.description.label": "How is the service delivered?",
  "delivery.description.help": "Describe how the service is delivered. If the service is delivered e.g. via specific actors or associated consultants, this can be specified here.",
  "delivery.description.required": "Please describe how the service is delivered",
  "delivery.deadline.question": "Is the service delivered through tender with application deadline?",
  "delivery.deadline.help": "Is the service delivered through tender with application deadline? Select yes/no.",
  "delivery.deadline.label": "What is the application deadline?",
  "delivery.deadline.helpText": "Set date for the application deadline.",
  "delivery.deadline.required": "Please enter date",
  "delivery.userFee.label": "Are there requirements for user payment to receive the service?",
  "delivery.userFee.help": "Are there requirements for user payment to receive the service? If yes, use the comment field for further explanation or clarification.",
  "delivery.userFee.comment.label": "Do you have a comment on user payment?",
  "delivery.userFee.required": "Please select an option",
  "delivery.userFeeComments.required": "Please add a comment",

  "contact.title": "Contact information and supplier",
  "contact.name.label": "Name",
  "contact.name.help": "Your information is set automatically, but you can change who is the contact person for the service.",
  "contact.name.required": "Please enter the name of the contact person",
  "contact.email.label": "Email address",
  "contact.email.required": "Please enter email address",
  "contact.phone.label": "Phone number",
  "contact.phone.required": "Please enter phone number",
  "contact.phone.maxLength": "Phone number can be a maximum of 15 characters",
  "contact.supplier.question": "Who delivers the service?",
  "contact.supplier.info": "The supplier field is filled automatically from the profile information.",
  "contact.client.question": "Who is the client?",
  "contact.client.info": "The supplier field is filled automatically from the profile information.",
  "contact.client.placeholder": "Please add client",
  "contact.client.dialogTitle": "Add client",
  "contact.client.required": "Please add at least one client",

  "eea.title": "EEA articles",
  "eea.applies.label": "Does the service apply EEA articles?",
  "eea.applies.help": "Answer no if the service does not apply EEA articles.",
  "eea.articles.question": "Which EEA articles are applied?",
  "eea.articles.help": "Select one or more EEA articles from the list to specify which are applied.",
  "eea.articles.placeholder": "Please add applied articles",
  "eea.articles.dialogTitle": "Add EEA articles",
  "eea.comments.label": "Do you have comments on the EEA articles?",
  "eea.comments.help": "Elaborate here for clarification.",
  "eea.comments.outsideLabel": "Do you have comments on why the service falls outside EEA regulations?",
  "eea.comments.outsideHelp": "Elaborate why the service falls outside EEA regulations.",
  "eea.comments.maxLength": "Maximum 500 characters",

  "summary.title": "Summary",
  "summary.inactiveWarning.title": "For the service to get the status \"Active\" you must change the following:",
  "summary.inactiveWarning.validFrom": "must be today or earlier than today's date",
  "summary.inactiveWarning.validTo": "must be today or later than today's date",

  "errors.fillRequired": "Please fill in all required fields",
  "errors.nameRequired": "Please enter the name of the service",

  "toasts.created": "The service has been created",
  "toasts.published": "The service has been published",
  "toasts.draftSaved": "The draft has been saved",
  "toasts.draftDeleted": "The draft has been deleted",
  "toasts.error": "Something went wrong",

  "missingServices": "You are missing services",
  "missingServicesText": "Edit your services, so they can be referred to",

  "templates.info": "You can choose a template in the list below, or use an empty form.",
  "templates.useTemplate": "Use template",
  "templates.emptyForm": "Use empty form",

  "purpose": "Purpose"
}
